module.exports = __webpack_public_path__ + "assets/img/1-6.25377fd1.png";